import React, { useEffect, useRef, useState } from 'react'
import '../styles/benRobot.css'

const DEFAULTS = {
  lidL: 0.04, lidR: 0.04, lowL: 0, lowR: 0, slant: 0,
  browYL: 0, browYR: 0, browAL: 0, browAR: 0,
  sx: 1, sy: 1, gx: 0, gy: 0, pr: 1, ir: 1, heart: 0,
  o: 0, s: 0.3, w: 1, skew: 0, blush: 0.12,
  tilt: 0, dy: 0, glow: 0.25,
  aRU: -9, aRE: -8, aLU: 9, aLE: 8, wv: 0,
  fcR: 0.25, fcL: 0.25, spR: 5, spL: 5,
  star: 0, shade: 0, tear: 0, tg: 0, kiss: 0, zz: 0
}

export const EXPRESSIONS = {
  neutral: {},
  smile: { s: 0.45, blush: 0.22, lowL: 0.08, lowR: 0.08 },
  happy: { aRU: -150, aRE: -15, wv: 1, fcR: 0, spR: 14, s: 0.85, lowL: 0.3, lowR: 0.3, browYL: -2, browYR: -2, blush: 0.55, o: 0.12, lidL: 0.02, lidR: 0.02 },
  laugh: { aRU: -35, aRE: -25, aLU: 35, aLE: 25, fcR: 0.2, fcL: 0.2, spR: 10, spL: 10, s: 1, o: 0.55, lowL: 0.65, lowR: 0.65, lidL: 0.3, lidR: 0.3, browYL: -3, browYR: -3, blush: 0.85, tilt: -5, w: 1.1 },
  surprised: { aRU: -140, aRE: -20, aLU: 140, aLE: 20, fcR: 0, fcL: 0, spR: 18, spL: 18, sy: 1.28, sx: 1.1, browYL: -8, browYR: -8, o: 0.75, w: 0.5, s: 0, lidL: 0, lidR: 0, pr: 0.7, ir: 1.05, blush: 0.1 },
  sad: { aRU: 3, aRE: -5, aLU: -3, aLE: 5, fcR: 0.4, fcL: 0.4, spR: 1, spL: 1, browAL: -11, browAR: 11, browYL: 1, browYR: 1, lidL: 0.3, lidR: 0.3, slant: -7, s: -0.7, w: 0.85, pr: 1.25, tilt: 4, dy: 2, blush: 0, gy: 3 },
  angry: { aRU: -15, aRE: -75, aLU: 15, aLE: 75, fcR: 1, fcL: 1, spR: 0, spL: 0, browAL: 13, browAR: -13, browYL: 2, browYR: 2, lidL: 0.28, lidR: 0.28, slant: 8, s: -0.55, o: 0.1, w: 1.05, pr: 0.8, blush: 0 },
  thinking: { aRU: -158, aRE: -112, fcR: 0.6, browYL: -7, browYR: 0, browAL: -5, s: 0.05, w: 0.6, gx: -4, gy: -3.5, lidL: 0.08, lidR: 0.12, tilt: 5, skew: 0.5 },
  wink: { aRU: -150, aRE: -15, wv: 1, fcR: 0, spR: 14, s: 0.85, skew: 0.2, lidR: 1, lowR: 0.4, browYR: 2, lowL: 0.25, blush: 0.6, o: 0.14, tilt: 4 },
  love: { aRU: -45, aRE: -10, aLU: 45, aLE: 10, fcR: 0.3, fcL: 0.3, heart: 1, s: 0.9, o: 0.18, blush: 0.85, lowL: 0.25, lowR: 0.25, browYL: -3, browYR: -3 },
  smirk: { aRU: -28, aRE: 73, fcR: 0.8, s: 0.35, skew: 0.7, browYL: -6, browAL: -4, lidR: 0.18, blush: 0.2, tilt: -3 },
  sleepy: { aRU: 2, aLU: -2, zz: 1, lidL: 0.65, lidR: 0.65, browYL: 2, browYR: 2, s: 0.15, o: 0.22, w: 0.7, gy: 2, tilt: -5, dy: 2 },
  listening: { aRU: -25, aRE: -10, aLU: 25, aLE: 10, browYL: -4, browYR: -4, sy: 1.1, sx: 1.05, s: 0.25, tilt: 6, glow: 1 },
  curious: { aRU: -20, aRE: -15, browYL: -6, browYR: -1, browAL: -4, s: 0.15, tilt: 5, sy: 1.06 },
  excited: { aRU: -150, aRE: -15, aLU: 150, aLE: 15, wv: 1, fcR: 0, fcL: 0, spR: 16, spL: 16, star: 1, s: 1, o: 0.5, lowL: 0.35, lowR: 0.35, browYL: -4, browYR: -4, blush: 0.6, glow: 0.9, sy: 1.08, sx: 1.06 },
  cool: { aRU: -28, aRE: 73, aLU: 28, aLE: -73, fcR: 0.8, fcL: 0.8, shade: 1, s: 0.5, skew: 0.6, browYL: -2, browYR: -2, tilt: -3, blush: 0.1 },
  cry: { tear: 1, aRU: 5, aRE: -6, aLU: -5, aLE: 6, fcR: 0.5, fcL: 0.5, browAL: -12, browAR: 12, browYL: 1, browYR: 1, lidL: 0.35, lidR: 0.35, slant: -6, s: -0.8, o: 0.3, w: 0.9, pr: 1.3, blush: 0.5, tilt: 3, dy: 2, gy: 3 },
  silly: { tg: 1, aRU: -150, aRE: -15, aLU: 150, aLE: 15, wv: 1, fcR: 0, fcL: 0, spR: 16, spL: 16, o: 0.42, s: 0.6, lowL: 0.3, lowR: 0.3, lidR: 0.55, tilt: 6, browYL: -5, browAR: 6, w: 1.05, blush: 0.5 },
  shy: { aRU: -20, aRE: 125, aLU: 20, aLE: -125, fcR: 0.8, fcL: 0.8, blush: 1, gx: -3, gy: 5, s: 0.3, w: 0.65, lidL: 0.25, lidR: 0.25, browAL: -6, browAR: 6, browYL: -2, browYR: -2, tilt: 4, dy: 2 },
  kiss: { aRU: -45, aRE: -10, aLU: 45, aLE: 10, kiss: 1, w: 0.32, o: 0.3, s: 0.3, lidL: 0.4, lidR: 0.4, browYL: -4, browYR: -4, blush: 0.85, tilt: -4, lowL: 0.2, lowR: 0.2 }
}

const TAP_ORDER = ['happy', 'laugh', 'surprised', 'wink', 'love', 'excited', 'cool', 'silly', 'kiss', 'shy', 'sad', 'cry', 'angry', 'thinking', 'smirk', 'sleepy']

const TAP_LINES = {
  happy: 'Hi! I am Ben. Nice to see you.',
  laugh: 'Ha ha ha! That is funny.',
  surprised: 'Oh wow! I did not expect that.',
  wink: 'Hey you. I know a secret.',
  love: 'Aww, thank you. I like you too.',
  excited: 'Yay! This is so exciting!',
  cool: 'Yeah. I am pretty cool.',
  silly: 'Bleh! I am being silly.',
  kiss: 'Mwah! That one is for you.',
  shy: 'Oh. You are making me blush.',
  sad: 'I feel a little sad today.',
  cry: 'Sniff. Please do not leave me.',
  angry: 'Hmph. I am very cross.',
  thinking: 'Hmm. Let me think about that.',
  smirk: 'I think I know something you do not.',
  sleepy: 'I am so sleepy. Yawn.'
}

const LABELS = {
  happy: 'Happy', laugh: 'Laughing', surprised: 'Surprised', wink: 'Winking', love: 'Love',
  excited: 'Excited', cool: 'Cool', silly: 'Silly', kiss: 'Kiss', shy: 'Shy',
  sad: 'Sad', cry: 'Crying', angry: 'Angry', thinking: 'Thinking', smirk: 'Smirking', sleepy: 'Sleepy'
}

const IDLE_CHOICES = ['happy', 'smirk', 'curious', 'wink', 'surprised', 'happy', 'cool', 'silly', 'excited', 'shy', 'kiss']

const FINGERS = [
  { x: -6.6, l1: 6.5, l2: 5 },
  { x: -2.2, l1: 8, l2: 6 },
  { x: 2.2, l1: 7.5, l2: 5.5 },
  { x: 6.6, l1: 5.5, l2: 4.2 }
]

const starPoints = (() => {
  const out = []
  for (let i = 0; i < 10; i += 1) {
    const r = i % 2 === 0 ? 10.5 : 4.4
    const a = -Math.PI / 2 + (i * Math.PI) / 5
    out.push(`${(Math.cos(a) * r).toFixed(2)},${(Math.sin(a) * r).toFixed(2)}`)
  }
  return out.join(' ')
})()


let wordSink = null
export const benWord = (word) => {
  if (wordSink) wordSink(word)
}

const LOOK_KEY = 'ben_look_v1'
const HUES = [193, 330, 140, 45, 265, 10, 215]
const DEFAULT_LOOK = { replies: 0, hue: 193, suit: 215, items: [] }

const ITEMS = {
  headphones: { re: /\b(music|song|songs|sing|singing|listen|sound|beat|audio|radio)\b/i, say: 'Music! I grew headphones.' },
  flower: { re: /\b(flower|flowers|garden|spring|plant|plants|nature|tree|trees)\b/i, say: 'Flowers! I picked one.' },
  scarf: { re: /\b(cold|winter|snow|warm|cozy|chilly)\b/i, say: 'Brr. I made a scarf.' },
  cape: { re: /\b(hero|super|power|strong|brave|fight|save|adventure)\b/i, say: 'A hero needs a cape.' },
  bow: { re: /\b(party|fancy|dress|wedding|suit|dance|dancing|birthday)\b/i, say: 'Fancy! Bow tie time.' },
  beanie: { re: /\b(sleep|tired|night|dream|rest|bed|nap)\b/i, say: 'Cozy. I made a beanie.' },
  specs: { re: /\b(read|book|books|study|learn|school|smart|code|coding)\b/i, say: 'Learning! I grew glasses.' }
}

const loadLook = () => {
  try {
    const raw = JSON.parse(window.localStorage.getItem(LOOK_KEY) || 'null')
    if (raw && typeof raw === 'object') {
      return {
        ...DEFAULT_LOOK,
        replies: Math.max(0, Number(raw.replies) || 0),
        hue: Number.isFinite(raw.hue) ? raw.hue : DEFAULT_LOOK.hue,
        suit: Number.isFinite(raw.suit) ? raw.suit : DEFAULT_LOOK.suit,
        items: Array.isArray(raw.items) ? raw.items.filter((key) => ITEMS[key]) : []
      }
    }
  } catch (err) { /* ignore */ }
  return { ...DEFAULT_LOOK, items: [] }
}

const levelFor = (n) => Math.floor((Math.sqrt(8 * n + 1) - 1) / 2)

const palette = (hue, suit) => {
  const alt = (hue + 150) % 360
  return {
    main: `hsl(${hue}, 100%, 67%)`,
    light: `hsl(${hue}, 100%, 92%)`,
    iris: `hsl(${hue}, 95%, 62%)`,
    dark: `hsl(${hue}, 80%, 27%)`,
    deep: `hsl(${hue}, 85%, 20%)`,
    alt: `hsl(${alt}, 72%, 60%)`,
    altDark: `hsl(${alt}, 72%, 38%)`,
    suitA: `hsl(${suit}, 16%, 40%)`,
    suitB: `hsl(${suit}, 24%, 19%)`,
    shadow: `hsla(${hue}, 100%, 65%, 0.2)`
  }
}

const NUMBERS = { zero: 0, one: 1, two: 2, three: 3, four: 4, five: 5, six: 6, seven: 7, eight: 8, nine: 9, ten: 10 }

const gestureFor = (raw) => {
  const w = String(raw || '').toLowerCase().replace(/[^a-z0-9']/g, '')
  if (!w) return null
  if (/^\d+$/.test(w) && Number(w) <= 10) return { kind: 'count', n: Number(w) }
  if (Object.prototype.hasOwnProperty.call(NUMBERS, w)) return { kind: 'count', n: NUMBERS[w] }
  if (['hello', 'hi', 'hey', 'bye', 'goodbye', 'welcome'].includes(w)) return { kind: 'wave' }
  if (['hand', 'hands', 'finger', 'fingers', 'palm', 'thumb', 'fist'].includes(w)) return { kind: 'inspect' }
  if (['i', 'me', 'my', 'myself', "i'm", 'im', "i'll", "i've"].includes(w)) return { kind: 'self' }
  if (['you', 'your', 'yours', 'look', 'this', 'that', 'here', 'there', 'see', 'watch'].includes(w)) return { kind: 'point' }
  if (['yes', 'yeah', 'yep', 'sure', 'okay', 'ok', 'right', 'correct', 'exactly', 'definitely'].includes(w)) return { kind: 'nod' }
  if (['no', 'not', 'never', "don't", "can't", 'cannot', 'nope', "won't"].includes(w)) return { kind: 'no' }
  if (['head', 'face', 'eyes', 'eye', 'smile', 'mouth', 'brain', 'think', 'mind', 'idea'].includes(w)) return { kind: 'face' }
  if (['feet', 'foot', 'leg', 'legs', 'walk', 'walking', 'step', 'dance', 'dancing', 'run', 'jump'].includes(w)) return { kind: 'march' }
  if (['body', 'robot', 'everything', 'world', 'big'].includes(w)) return { kind: 'present' }
  return null
}

const GESTURE_TIME = { count: 1.5, inspect: 3, wave: 1.7, self: 1.2, point: 1.4, nod: 0.9, no: 1.3, face: 1.4, march: 1.6, present: 1.5 }
const GESTURE_RANK = { count: 3, inspect: 3, wave: 3, no: 3, point: 2, self: 2, face: 2, march: 2, present: 2, nod: 1 }
const pickFingers = (open) => [0, 1, 2, 3, 4].map((i) => (open.includes(i) ? 0 : 1))
const COUNT_ORDER = [1, 2, 3, 4, 0]


let commandSink = null
const SIZE_KEY = 'ben_size_v1'
const loadSize = () => {
  try {
    const v = Number(window.localStorage.getItem(SIZE_KEY))
    return v >= 0.3 && v <= 2 ? v : 1
  } catch (err) { return 1 }
}
const saveSize = (v) => {
  try { window.localStorage.setItem(SIZE_KEY, String(v)) } catch (err) { /* ignore */ }
}
const STAY_KEY = 'ben_stay_v1'
const loadStay = () => {
  try { return window.localStorage.getItem(STAY_KEY) === '1' } catch (err) { return false }
}
const saveStay = (on) => {
  try { window.localStorage.setItem(STAY_KEY, on ? '1' : '0') } catch (err) { /* ignore */ }
}

export const avatarCommand = (raw) => {
  if (!commandSink) return null
  const t = String(raw || '').toLowerCase().replace(/['\u2019]/g, '').replace(/[^a-z0-9\s]/g, ' ').replace(/\s+/g, ' ').trim()
  if (!t) return null
  const count = t.split(' ').length
  const about = /\b(avatar|robot|yourself|body|ben|you|your)\b/.test(t)
  if (count > 12 || !(count <= 6 || about)) return null
  const has = (re) => re.test(t)
  const act = (cmd, reply, mood) => {
    commandSink(cmd)
    return { reply, mood: mood || 'smile' }
  }

  if (has(/\b(hide|disappear|vanish)\b/) && has(/\b(avatar|robot|yourself|body|you)\b/)) {
    return act({ type: 'hide' }, 'Okay, I am hiding. Say "show yourself" and I will come back.', 'shy')
  }
  if (has(/\b(show|appear|unhide|bring back)\b/) && has(/\b(avatar|robot|yourself|body|you)\b/)) {
    return act({ type: 'show' }, 'Ta-da! I am back.', 'happy')
  }
  if (
    has(/\b(dont|do not|stop|quit|never|no more)\b (you )?(to )?(moving|move|walking|walk|wandering|wander|roaming|roam|running|run|going around)\b/) ||
    has(/\b(stay|stand|keep|be|remain|hold)\b( \w+)? (still|here|put|there|frozen)\b/) ||
    has(/\b(freeze|hold still|stand still|stay still|be still)\b/)
  ) {
    return act({ type: 'stay' }, 'Okay, I will stay right here and not move. Tell me "you can move" whenever you want me to walk around again.', 'smile')
  }
  if (
    has(/\b(you can|can you|feel free to|go ahead and|start|resume|continue|begin|please)\b (to )?(moving|move|walking|walk|wandering|wander|roaming|roam)\b/) ||
    has(/\b(move|walk|roam|wander)\b (again|freely|around|now|free)\b/) ||
    has(/\b(go free|move around|walk around)\b/)
  ) {
    return act({ type: 'roam' }, 'Yay! I can walk around again.', 'happy')
  }
  if (has(/\b(come|get|walk|move)\b (over )?(here|to me|closer|over here)\b/)) {
    return act({ type: 'come' }, 'Coming!', 'happy')
  }
  const sizeWord = t.match(/\b(tiny|mini|small|smaller|little|shrink|big|bigger|large|larger|huge|giant|grow|normal size|regular size|default size|original size|back to normal)\b/)
  if (sizeWord && (count <= 4 || has(/\b(make|be|get|become|turn|shrink|grow|resize)\b/))) {
    const w = sizeWord[1]
    if (/normal|regular|default|original/.test(w)) return act({ type: 'size', to: 1 }, 'Back to my normal size.', 'smile')
    if (/^(tiny|mini)$/.test(w)) return act({ type: 'size', to: 0.4 }, 'Eep! I am tiny now.', 'happy')
    if (/^(small|little|shrink)$/.test(w)) return act({ type: 'size', to: 0.6 }, 'Okay, I made myself small.', 'happy')
    if (w === 'smaller') return act({ type: 'size', by: 0.75 }, 'A bit smaller, done.', 'happy')
    if (/^(huge|giant)$/.test(w)) return act({ type: 'size', to: 1.8 }, 'Whoa, look how big I am!', 'excited')
    if (w === 'bigger') return act({ type: 'size', by: 1.3 }, 'A bit bigger, done.', 'happy')
    return act({ type: 'size', to: 1.4 }, 'Okay, I made myself big.', 'excited')
  }
  if (has(/\b(go|move|walk|run|stand|sit|stay|head)\b/) && has(/\b(left|right|top|bottom|middle|center|centre|corner|up|down)\b/)) {
    const cmd = { type: 'goto', fx: null, fy: null, stay: has(/\b(stay|stand|sit|wait|stop)\b/) }
    if (has(/\bleft\b/)) cmd.fx = 0.02
    else if (has(/\bright\b/)) cmd.fx = 0.98
    if (has(/\b(top|up)\b/)) cmd.fy = 0.04
    else if (has(/\b(bottom|down)\b/)) cmd.fy = 1
    if (has(/\b(middle|center|centre)\b/)) {
      if (cmd.fx === null) cmd.fx = 0.5
      if (cmd.fy === null) cmd.fy = 0.5
    }
    if (cmd.fx !== null || cmd.fy !== null) return act(cmd, 'Okay, going there.', 'happy')
  }
  if (has(/\b(dance|dancing|jump|hop|wave)\b/) && (count <= 5 || has(/\b(can|could|will|would|please|lets|let s) (you|us)?\b/))) {
    const type = has(/\b(dance|dancing)\b/) ? 'dance' : has(/\bwave\b/) ? 'wave' : 'jump'
    return act({ type }, type === 'dance' ? 'Watch this!' : type === 'wave' ? 'Hi there!' : 'Here I go!', 'excited')
  }
  if (has(/\b(yourself|your avatar|your body|avatar)\b/) && has(/\b(make|be|become|turn|change|do|can you|could you|please)\b/)) {
    return act(
      { type: 'none' },
      'I do not understand that one yet. Honestly, I only follow set commands for my avatar: stay still, move again, come here, go left or right, small or big, dance, jump, wave, hide, show. Try one of those.',
      'sad'
    )
  }
  return null
}

const HEART_D = 'M0 7 C-11 -1 -10 -10 -4.5 -10 C-2 -10 0 -8 0 -6.5 C0 -8 2 -10 4.5 -10 C10 -10 11 -1 0 7Z'

const RATE = { lidL: 26, lidR: 26, o: 22, gx: 14, gy: 14, glow: 6, shade: 10, tear: 6, zz: 5, kiss: 10, aRU: 16, aRE: 18, aLU: 16, aLE: 18 }
const KEYS = Object.keys(DEFAULTS)

const clamp = (v, lo, hi) => Math.max(lo, Math.min(hi, v))
const f = (v) => Number(v).toFixed(2)
const qc = (mid, y0, y1) => 2 * mid - (y0 + y1) / 2

const BenRobot = ({ speaking, listening, thinking, studying, typing, mood, moodAt, said, heardText, heardMood, heardAt, voiced, onSay }) => {
  const els = useRef({})
  const rootRef = useRef(null)
  const stRef = useRef(null)
  const propsRef = useRef({})
  const pokeRef = useRef({ name: '', until: 0, talkUntil: 0 })
  const tapIndex = useRef(-1)
  const labelTimer = useRef(null)
  const [label, setLabel] = useState('')
  const [look, setLook] = useState(loadLook)
  const lookRef = useRef(look)
  const A = palette(look.hue, look.suit)
  const has = (key) => look.items.includes(key)
  const level = levelFor(look.replies)

  lookRef.current = look
  propsRef.current = { speaking, listening, thinking, studying, typing, mood, moodAt, said, heardText, heardMood, heardAt, voiced }

  useEffect(() => {
    try { window.localStorage.setItem(LOOK_KEY, JSON.stringify(look)) } catch (err) { /* ignore */ }
  }, [look])

  const reg = (key) => (el) => { els.current[key] = el }

  useEffect(() => () => window.clearTimeout(labelTimer.current), [])

  useEffect(() => {
    const calm = typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches
    const st = {
      cur: { ...DEFAULTS },
      blink: { at: 1.5, t: -1 },
      idle: { name: '', until: 0, next: 3 },
      look: { x: 0, y: 0, tx: 0, ty: 0, next: 0 },
      ptr: { x: 0, y: 0, at: -99 },
      lastSpeak: -99,
      seenMoodAt: 0,
      replyUntil: 0,
      pos: { x: 0, y: 0, ready: false },
      mv: { tgt: null, wait: 1.2, speed: 0, dx: 0, dy: 0, phase: 0, walk: 0 },
      drag: { on: false, moved: false, ox: 0, oy: 0, sx: 0, sy: 0 },
      hop: -99,
      gest: { kind: '', until: 0, t0: -99, n: 0, prog: false },
      beat: { t0: -99, side: 'R' },
      beatN: 0,
      fing: { R: [0.25, 0.25, 0.25, 0.25, 0.25], L: [0.25, 0.25, 0.25, 0.25, 0.25] },
      lastWordEvt: -99,
      script: { words: [], i: 0, next: 0, on: false, armed: 0 },
      speakStart: -99,
      wasSpeaking: false,
      wasBusy: false,
      heard: { name: '', until: 0 },
      seenHeardAt: 0,
      ptrPx: { x: 0, y: 0 },
      stay: loadStay(),
      size: loadSize(),
      goto: null,
      inspectNext: performance.now() / 1000 + 9,
      spark: -99,
      sparkOn: false
    }
    stRef.current = st
    let raf = 0
    let last = performance.now()

    const setA = (key, attr, value) => {
      const el = els.current[key]
      if (el) el.setAttribute(attr, value)
    }

    const onMove = (event) => {
      const root = rootRef.current
      if (!root) return
      const box = root.getBoundingClientRect()
      const cx = box.left + box.width / 2
      const cy = box.top + box.height * 0.26
      st.ptr.x = clamp((event.clientX - cx) / (window.innerWidth * 0.35), -1, 1)
      st.ptr.y = clamp((event.clientY - cy) / (window.innerHeight * 0.35), -1, 1)
      st.ptr.at = performance.now() / 1000
      st.ptrPx.x = event.clientX
      st.ptrPx.y = event.clientY
    }
    window.addEventListener('pointermove', onMove)

    const applyEye = (side, cx, sgn, lid, low, d) => {
      setA(`eye${side}`, 'transform', `translate(${cx} 96) scale(${d.sx.toFixed(3)} ${d.sy.toFixed(3)})`)
      const base = -15 + lid * 32
      const yIn = base + d.slant
      const yOut = base - d.slant * 0.5
      const yLx = sgn === 1 ? yOut : yIn
      const yRx = sgn === 1 ? yIn : yOut
      const ctrl = (yLx + yRx) / 2 + 5
      setA(`upper${side}`, 'd', `M-25 -34 L25 -34 L25 ${f(yRx)} Q0 ${f(ctrl)} -25 ${f(yLx)}Z`)
      setA(`line${side}`, 'd', `M-25 ${f(yLx)} Q0 ${f(ctrl)} 25 ${f(yRx)}`)
      const yb = 15 - low * 22
      setA(`lower${side}`, 'd', `M-25 34 L25 34 L25 ${f(yb)} Q0 ${f(yb - 6)} -25 ${f(yb)}Z`)
      setA(`look${side}`, 'transform', `translate(${f(d.gx)} ${f(d.gy)})`)
      setA(`irisC${side}`, 'r', f(9.2 * d.ir))
      setA(`pupilC${side}`, 'r', f(4.3 * d.pr))
      setA(`irisG${side}`, 'opacity', f(1 - Math.max(d.heart, d.star)))
      setA(`heart${side}`, 'opacity', f(d.heart))
      setA(`star${side}`, 'opacity', f(d.star))
    }

    const applyMouth = (d) => {
      const mx = 100
      const my = 150
      const hw = 27 * d.w
      const xL = mx - hw
      const xR = mx + hw
      const cyL = my - (d.s - d.skew) * 8
      const cyR = my - (d.s + d.skew) * 8
      const yU = my - 1 + d.s * 2
      const open = clamp(d.o, 0, 1) * 26
      const uoMid = yU - 2.5
      const uiMid = yU + 0.6
      const liMid = uiMid + open
      const loMid = liMid + 6 + d.o * 2
      const P = (x, y) => `${x.toFixed(1)} ${y.toFixed(1)}`
      setA('lips', 'd', `M${P(xL, cyL)} Q${P(mx, qc(uoMid, cyL, cyR))} ${P(xR, cyR)} Q${P(mx, qc(loMid, cyR, cyL))} ${P(xL, cyL)}Z`)
      setA('mline', 'd', `M${P(xL, cyL)} Q${P(mx, qc(uiMid, cyL, cyR))} ${P(xR, cyR)}`)
      setA('mline', 'opacity', f(1 - clamp(open / 3, 0, 1)))
      const inner = `M${P(xL + 2, cyL)} Q${P(mx, qc(uiMid, cyL, cyR))} ${P(xR - 2, cyR)} Q${P(mx, qc(liMid, cyR, cyL))} ${P(xL + 2, cyL)}Z`
      setA('mopen', 'd', inner)
      setA('mclip', 'd', inner)
      setA('mopen', 'opacity', f(clamp(open / 1.5, 0, 1)))
      setA('teeth', 'x', f(xL + 5))
      setA('teeth', 'width', f(Math.max(2, xR - xL - 10)))
      setA('teeth', 'y', f(uiMid - 3))
      setA('teeth', 'height', f(Math.min(open * 0.55, 10) + 3))
      setA('tongue', 'cy', f(liMid - 2))
      setA('tongue', 'rx', f(10 * d.w))
      setA('tongue', 'opacity', f(clamp((open - 5) / 6, 0, 1)))
      setA('tongueOut', 'transform', `translate(${f(mx + 5)} ${f(loMid - 3)}) scale(${f(0.85 + d.tg * 0.15)} ${f(Math.max(0.01, d.tg))})`)
      setA('tongueOut', 'opacity', f(clamp(d.tg * 1.4, 0, 1)))
      setA('gloss', 'cy', f(loMid - 2.4))
      setA('gloss', 'rx', f(7 * d.w))
      const dim = clamp(d.s, 0, 1) * 0.5
      setA('dimL', 'd', `M${f(xL - 2.5)} ${f(cyL - 3)} Q${f(xL - 6)} ${f(cyL)} ${f(xL - 2.5)} ${f(cyL + 3)}`)
      setA('dimR', 'd', `M${f(xR + 2.5)} ${f(cyR - 3)} Q${f(xR + 6)} ${f(cyR)} ${f(xR + 2.5)} ${f(cyR + 3)}`)
      setA('dimL', 'opacity', f(dim))
      setA('dimR', 'opacity', f(dim))
    }

    const applyHand = (side, c, spread) => {
      FINGERS.forEach((fg, i) => {
        const curl = c[i + 1]
        const h1 = fg.l1 * (1 - 0.42 * curl)
        const h2 = fg.l2 * (1 - 0.78 * curl)
        setA(`fg${side}${i}`, 'transform', `translate(${fg.x} 8) rotate(${f((i - 1.5) * spread * 0.9)})`)
        setA(`fa${side}${i}`, 'height', f(h1))
        setA(`fb${side}${i}`, 'y', f(h1 - 1))
        setA(`fb${side}${i}`, 'height', f(h2 + 1))
      })
      const tc = c[0]
      setA(`tm${side}`, 'transform', `translate(-8 4) rotate(${f(40 - tc * 26 + spread * 0.4)})`)
      setA(`ta${side}`, 'height', f(6.5 * (1 - 0.25 * tc)))
      setA(`tb${side}`, 'y', f(6.5 * (1 - 0.25 * tc) - 1))
      setA(`tb${side}`, 'height', f(5.5 * (1 - 0.55 * tc) + 1))
    }

    const flash = (text, ms) => {
      setLabel(text)
      window.clearTimeout(labelTimer.current)
      labelTimer.current = window.setTimeout(() => setLabel(''), ms || 2600)
    }

    const startGesture = (g, now) => {
      const cur = st.gest
      const rank = GESTURE_RANK[g.kind] || 1
      if (now < cur.until - 0.5 && rank <= (GESTURE_RANK[cur.kind] || 0)) return
      st.gest = { kind: g.kind, until: now + (g.dur || GESTURE_TIME[g.kind] || 1.2), t0: now, n: g.n || 0, prog: Boolean(g.prog) }
    }

    const onWord = (word) => {
      const now = performance.now() / 1000
      const g = gestureFor(word)
      if (g) {
        startGesture(g, now)
        return
      }
      st.beatN += 1
      if (String(word).length >= 5 || st.beatN % 3 === 0) {
        st.beat = { t0: now, side: st.beat.side === 'R' ? 'L' : 'R' }
      }
    }

    wordSink = (word) => {
      st.lastWordEvt = performance.now() / 1000
      onWord(word)
    }

    commandSink = (cmd) => {
      const now = performance.now() / 1000
      const root = rootRef.current
      if (cmd.type === 'hide') {
        if (root) root.style.display = 'none'
      } else if (cmd.type === 'show') {
        if (root) root.style.display = ''
      } else if (cmd.type === 'stay') {
        st.stay = true
        saveStay(true)
        st.goto = null
        st.mv.tgt = null
      } else if (cmd.type === 'roam') {
        st.stay = false
        saveStay(false)
        st.goto = null
        st.mv.tgt = null
        st.mv.wait = 0.3
      } else if (cmd.type === 'come') {
        const fresh = now - st.ptr.at < 20
        st.goto = { cx: fresh ? st.ptrPx.x : window.innerWidth / 2, cy: fresh ? st.ptrPx.y : window.innerHeight / 2, set: false }
      } else if (cmd.type === 'goto') {
        st.goto = { fx: cmd.fx, fy: cmd.fy, set: false }
        if (cmd.stay) {
          st.stay = true
          saveStay(true)
        }
      } else if (cmd.type === 'dance') {
        st.hop = now
        startGesture({ kind: 'march', dur: 4.5 }, now)
      } else if (cmd.type === 'wave') {
        startGesture({ kind: 'wave', dur: 2.6 }, now)
      } else if (cmd.type === 'jump') {
        st.hop = now
      } else if (cmd.type === 'size') {
        st.size = clamp(cmd.to !== undefined ? cmd.to : st.size * cmd.by, 0.3, 2)
        saveSize(st.size)
        st.hop = now
      }
    }

    const grow = (spoken, heardWords) => {
      const cur = lookRef.current
      const replies = cur.replies + 1
      const next = { ...cur, replies, items: [...cur.items] }
      const notes = []
      const text = `${heardWords || ''} ${spoken || ''}`
      const found = Object.keys(ITEMS).find((key) => !cur.items.includes(key) && ITEMS[key].re.test(text))
      if (found) {
        next.items.push(found)
        notes.push(ITEMS[found].say)
      }
      if (levelFor(replies) > levelFor(cur.replies)) {
        let hue = HUES[Math.floor(Math.random() * HUES.length)]
        if (Math.abs(hue - cur.hue) < 50) hue = (cur.hue + 120) % 360
        next.hue = hue
        next.suit = Math.round((cur.suit + 25 + Math.random() * 40) % 360)
        notes.push(`Level ${levelFor(replies)}! New colors.`)
      }
      lookRef.current = next
      setLook(next)
      if (notes.length) {
        const now = performance.now() / 1000
        st.spark = now
        st.sparkOn = true
        st.hop = now
        flash(notes.join(' '), 4600)
      }
    }

    const frame = (t) => {
      const now = t / 1000
      const dt = Math.min(0.05, (t - last) / 1000)
      last = t
      const P = propsRef.current

      if (P.speaking) st.lastSpeak = now
      if (P.speaking && !st.wasSpeaking) st.speakStart = now
      st.wasSpeaking = Boolean(P.speaking)

      if (P.moodAt && P.moodAt !== st.seenMoodAt) {
        st.seenMoodAt = P.moodAt
        st.replyUntil = now + 4
        st.script = { words: String(P.said || '').split(/\s+/).filter(Boolean).slice(0, 70), i: 0, next: 0, on: true, armed: now }
        grow(P.said, P.heardText)
      }

      if (P.heardAt && P.heardAt !== st.seenHeardAt) {
        st.seenHeardAt = P.heardAt
        st.heard = { name: P.heardMood, until: now + 2.2 }
        String(P.heardText || '').split(/\s+/).slice(0, 12).some((word) => {
          const g = gestureFor(word)
          if (g && ['wave', 'inspect', 'count', 'no'].includes(g.kind)) {
            startGesture(g, now)
            return true
          }
          return false
        })
      }
      if (P.thinking && !st.wasBusy && now >= st.gest.until) startGesture({ kind: 'nod' }, now)
      st.wasBusy = Boolean(P.thinking)

      const sc = st.script
      if (sc.on) {
        const spoke = st.speakStart > sc.armed
        if (P.voiced && spoke && !P.speaking && now - st.lastSpeak > 0.8) {
          sc.on = false
        } else if (now - st.lastWordEvt >= 1) {
          const ready = P.voiced
            ? (P.speaking && now - st.speakStart > 1.2) || (!spoke && now > sc.armed + 1.8)
            : now > sc.armed + 0.5
          if (ready) {
            if (sc.i >= sc.words.length) {
              sc.on = false
            } else if (now >= sc.next) {
              onWord(sc.words[sc.i])
              sc.next = now + 0.2 + sc.words[sc.i].length * 0.028 + Math.random() * 0.06
              sc.i += 1
            }
          }
        }
      }
      const scriptTalking = st.script.on && !P.speaking && now > st.script.armed + (P.voiced ? 1.8 : 0.5) && st.script.i > 0

      const poke = pokeRef.current
      const pokeOn = poke.name && now < poke.until
      if (pokeOn && P.speaking) poke.until = Math.max(poke.until, now + 0.7)

      const dragging = st.drag.on && st.drag.moved
      let name = 'smile'
      if (dragging) name = 'surprised'
      else if (pokeOn) name = poke.name
      else if (P.listening) name = 'listening'
      else if (now < st.heard.until && EXPRESSIONS[st.heard.name]) name = st.heard.name
      else if (P.thinking || P.studying) name = 'thinking'
      else if (P.typing) name = 'curious'
      else if (P.speaking || now < st.replyUntil || now - st.lastSpeak < 2) name = EXPRESSIONS[P.mood] ? P.mood : 'happy'
      else if (now < st.idle.until) name = st.idle.name
      else if (!calm && now > st.idle.next) {
        st.idle.name = IDLE_CHOICES[Math.floor(Math.random() * IDLE_CHOICES.length)]
        st.idle.until = now + 1.6 + Math.random() * 1.2
        st.idle.next = st.idle.until + 2.5 + Math.random() * 3.5
        name = st.idle.name
      }

      const target = { ...DEFAULTS, ...(EXPRESSIONS[name] || {}) }

      const talking = P.speaking || now < poke.talkUntil || scriptTalking
      if (talking) {
        const big = name === 'laugh' ? 1.25 : 1
        const wave = (0.22 + 0.78 * Math.abs(Math.sin(now * 8.6)) * (0.55 + 0.45 * Math.abs(Math.sin(now * 3.1 + 1)))) * 0.85 * big
        target.o = clamp(target.o * 0.25 + wave, 0, 1)
        target.w = target.w * (0.82 + 0.22 * Math.sin(now * 5.1))
        target.browYL += Math.sin(now * 4.1) * 1.2
        target.browYR += Math.sin(now * 3.7 + 1) * 1.2
        target.tilt += Math.sin(now * 2.2) * 1.6
        target.glow = Math.max(target.glow, 0.7 + 0.3 * Math.sin(now * 10))
      } else if (name === 'sleepy') {
        target.o = 0.1 + 0.14 * (0.5 + 0.5 * Math.sin(now * 1.3))
      }

      const sway = calm ? 0 : 1
      target.tilt += Math.sin(now * 0.7) * 1.2 * sway
      target.dy += Math.sin(now * 1.1) * 1.1 * sway

      const g = st.gest
      const gOn = now < g.until && !dragging
      const gk = gOn ? g.kind : ''
      const gt = now - g.t0
      const rootBox = rootRef.current ? rootRef.current.getBoundingClientRect() : null
      let arrR = null
      let arrL = null

      if (!gk && !talking && !P.listening && !P.thinking && !P.typing && !calm && !pokeOn && !dragging && now > st.inspectNext) {
        st.inspectNext = now + 26 + Math.random() * 30
        if (Math.random() < 0.5) {
          startGesture({ kind: 'inspect' }, now)
          flash('Checking my fingers')
        } else {
          const n = 1 + Math.floor(Math.random() * 5)
          startGesture({ kind: 'count', n, prog: true, dur: n * 0.55 + 1.4 }, now)
          flash('Counting my fingers')
        }
      }

      if (gk === 'wave') {
        target.aRU = -150
        target.aRE = -15
        target.wv = 1
        target.spR = 14
        arrR = pickFingers([0, 1, 2, 3, 4])
      } else if (gk === 'count') {
        const nShow = g.prog ? Math.min(g.n, 1 + Math.floor(gt * 2.2)) : g.n
        const rN = Math.min(nShow, 5)
        target.aRU = -140 + Math.sin(gt * 8) * 3
        target.aRE = -20
        target.spR = 8
        arrR = pickFingers(COUNT_ORDER.slice(0, rN))
        if (nShow > 5) {
          target.aLU = 140
          target.aLE = 20
          target.spL = 8
          arrL = pickFingers(COUNT_ORDER.slice(0, nShow - 5))
        }
        target.gy -= 1.5
      } else if (gk === 'inspect') {
        target.aRU = -22
        target.aRE = 118 + Math.sin(gt * 2.4) * 8
        target.spR = 10
        arrR = [0, 1, 2, 3, 4].map((k) => 0.08 + 0.78 * Math.max(0, Math.sin(now * 9 - k * 0.95)))
        target.gx += 6
        target.gy += 6
        target.tilt += 4
        target.browYL -= 2
        target.browYR -= 2
      } else if (gk === 'self') {
        target.aRU = -26
        target.aRE = 116
        target.spR = 3
        arrR = [0.15, 0.1, 0.1, 0.1, 0.1]
      } else if (gk === 'point' && rootBox) {
        const fresh = now - st.ptr.at < 6
        const tx = fresh ? st.ptrPx.x : window.innerWidth / 2
        const ty = fresh ? st.ptrPx.y : window.innerHeight - 30
        const sx = rootBox.left + rootBox.width / 2
        const sy = rootBox.top + rootBox.height * 0.6
        const dx = tx - sx
        const dy = ty - sy
        if (Math.hypot(dx, dy) > 30) {
          const useR = dx >= 0
          const deg = clamp((Math.atan2(useR ? dx : -dx, dy) * 180) / Math.PI, 35, 175)
          if (useR) {
            target.aRU = -deg
            target.aRE = -4
            arrR = pickFingers([1])
            arrR[0] = 0.5
          } else {
            target.aLU = deg
            target.aLE = 4
            arrL = pickFingers([1])
            arrL[0] = 0.5
          }
        }
      } else if (gk === 'nod') {
        target.dy += Math.sin(gt * 12) * 3.4
      } else if (gk === 'no') {
        target.aRU = -100
        target.aRE = -70 + Math.sin(gt * 14) * 14
        arrR = pickFingers([1])
        target.tilt += Math.sin(gt * 12) * 7
        target.gx += Math.sin(gt * 12) * 3
      } else if (gk === 'face') {
        target.aRU = -158
        target.aRE = -112
        arrR = pickFingers([1])
        target.tilt += 4
      } else if (gk === 'present') {
        target.aRU = -62
        target.aRE = -8
        target.aLU = 62
        target.aLE = 8
        target.spR = 12
        target.spL = 12
        arrR = pickFingers([0, 1, 2, 3, 4])
        arrL = pickFingers([0, 1, 2, 3, 4])
      } else if (!gk && talking) {
        const bk = (now - st.beat.t0) / 0.4
        if (bk >= 0 && bk < 1) {
          const b = Math.sin(bk * Math.PI)
          if (st.beat.side === 'R') {
            target.aRU -= 26 * b
            target.aRE -= 36 * b
            target.spR += 6 * b
          } else {
            target.aLU += 26 * b
            target.aLE += 36 * b
            target.spL += 6 * b
          }
          target.dy += 2.4 * b
          target.browYL -= 1.6 * b
          target.browYR -= 1.6 * b
        }
      }

      const pointerFresh = now - st.ptr.at < 4
      if (P.typing && !P.thinking) {
        st.look.tx = 0
        st.look.ty = 0.95
      } else if (pointerFresh) {
        st.look.tx = st.ptr.x
        st.look.ty = st.ptr.y
      } else if (now > st.look.next && !calm) {
        st.look.tx = (Math.random() - 0.5) * 1.4
        st.look.ty = (Math.random() - 0.5) * 0.8
        st.look.next = now + 1.6 + Math.random() * 2
      }
      const lk = 1 - Math.exp(-dt * 8)
      st.look.x += (st.look.tx - st.look.x) * lk
      st.look.y += (st.look.ty - st.look.y) * lk
      const lookScale = name === 'thinking' ? 0.25 : name === 'sleepy' ? 0.3 : 1
      target.gx += st.look.x * 6 * lookScale
      target.gy += st.look.y * 4 * lookScale

      KEYS.forEach((key) => {
        const k = 1 - Math.exp(-dt * (RATE[key] || 9))
        st.cur[key] += (target[key] - st.cur[key]) * k
      })

      if (st.blink.t < 0 && now > st.blink.at) st.blink.t = 0
      let blinkV = 0
      if (st.blink.t >= 0) {
        st.blink.t += dt
        const k = st.blink.t / 0.16
        if (k >= 1) {
          st.blink.t = -1
          st.blink.at = now + (Math.random() < 0.2 ? 0.25 : 2 + Math.random() * 4)
        } else {
          blinkV = Math.sin(k * Math.PI)
        }
      }

      const d = st.cur
      const lidL = Math.max(d.lidL, blinkV)
      const lidR = Math.max(d.lidR, blinkV)

      const rootEl = rootRef.current
      let hopY = 0
      let lean = 0
      let bob = 0
      let swing = 0
      if (rootEl && rootEl.offsetWidth) {
        const W = window.innerWidth
        const H = window.innerHeight
        const bw = rootEl.offsetWidth
        const bh = rootEl.offsetHeight
        const maxX = Math.max(0, W - bw)
        const minY = 30
        const maxY = Math.max(minY, H - bh - 6)
        const pos = st.pos
        const mv = st.mv
        if (!pos.ready) {
          pos.x = maxX / 2
          pos.y = clamp(H * 0.3, minY, maxY)
          pos.ready = true
          rootEl.style.visibility = 'visible'
        }
        const holding = P.speaking || P.listening || P.typing || pokeOn || (gOn && gk !== 'march')
        let desired = 0
        if (!st.drag.on) {
          if (st.goto || (!holding && !calm && !st.stay)) {
            if (st.goto && !st.goto.set) {
              const gt2 = st.goto
              gt2.set = true
              const tx = gt2.cx !== undefined ? gt2.cx - bw / 2 : gt2.fx === null ? pos.x : gt2.fx * maxX
              const ty = gt2.cy !== undefined ? gt2.cy - bh * 0.6 : gt2.fy === null ? pos.y : minY + gt2.fy * (maxY - minY)
              mv.tgt = { x: clamp(tx, 0, maxX), y: clamp(ty, minY, maxY) }
              mv.wait = 0
            }
            if (!st.goto && mv.wait > 0) {
              mv.wait -= dt
            } else {
              if (!mv.tgt) {
                for (let i = 0; i < 6; i += 1) {
                  const cand = { x: Math.random() * maxX, y: minY + Math.random() * (maxY - minY) }
                  mv.tgt = cand
                  if (Math.hypot(cand.x - pos.x, cand.y - pos.y) > 120) break
                }
              }
              const ddx = mv.tgt.x - pos.x
              const ddy = mv.tgt.y - pos.y
              const dist = Math.hypot(ddx, ddy)
              if (dist < 6) {
                mv.tgt = null
                st.goto = null
                mv.wait = 1.2 + Math.random() * 3.6
              } else {
                desired = Math.min(125, 24 + dist * 1.5)
                mv.dx = ddx / dist
                mv.dy = ddy / dist
              }
            }
          }
          mv.speed += (desired - mv.speed) * (1 - Math.exp(-dt * 5))
          if (mv.speed < 0.5) mv.speed = 0
          pos.x += mv.dx * mv.speed * dt
          pos.y += mv.dy * mv.speed * dt * 0.8
        } else {
          mv.speed = 0
        }
        pos.x = clamp(pos.x, 0, maxX)
        pos.y = clamp(pos.y, minY, maxY)

        const marching = gk === 'march'
        mv.walk += ((marching ? 0.9 : clamp(mv.speed / 60, 0, 1)) - mv.walk) * (1 - Math.exp(-dt * 8))
        mv.phase += dt * (3 + mv.speed * 0.05 + (marching ? 5 : 0))
        swing = Math.sin(mv.phase)
        lean = clamp((mv.dx * mv.speed) / 125, -1, 1) * 6
        bob = Math.abs(swing) * -3.5 * mv.walk + Math.sin(now * 1.9) * 0.8
        const hk = (now - st.hop) / 0.55
        if (hk >= 0 && hk < 1) hopY = -Math.sin(hk * Math.PI) * 34
        if (marching) hopY -= Math.abs(Math.sin(now * 8)) * 6
        const growNow = (1 + Math.min(0.22, levelFor(lookRef.current.replies) * 0.02)) * st.size
        const depth = (dragging ? 1.05 : 0.84 + 0.26 * ((pos.y - minY) / Math.max(1, maxY - minY))) * growNow
        rootEl.style.transform = `translate3d(${pos.x.toFixed(1)}px, ${(pos.y + hopY).toFixed(1)}px, 0) scale(${depth.toFixed(3)})`
        rootEl.style.zIndex = st.drag.on ? '80' : '60'
      }

      setA('head', 'transform', `translate(0 ${f(d.dy)}) rotate(${f(d.tilt)} 100 130)`)
      applyEye('L', 72, 1, lidL, d.lowL, d)
      applyEye('R', 128, -1, lidR, d.lowR, d)
      setA('browL', 'transform', `translate(72 ${f(69 + d.browYL)}) rotate(${f(d.browAL)})`)
      setA('browR', 'transform', `translate(128 ${f(69 + d.browYR)}) rotate(${f(d.browAR)})`)
      setA('blushL', 'opacity', f(d.blush))
      setA('blushR', 'opacity', f(d.blush))
      applyMouth(d)
      const glow = clamp(d.glow, 0, 1)
      setA('earL', 'opacity', f(0.25 + glow * 0.75))
      setA('earR', 'opacity', f(0.25 + glow * 0.75))
      setA('bulb', 'opacity', f(0.35 + glow * 0.65))
      setA('halo', 'opacity', f(glow * 0.45))

      const walk = st.mv.walk
      let legL = swing * 13 * walk
      let legLift = Math.max(0, swing) * 8 * walk
      let legRift = Math.max(0, -swing) * 8 * walk
      if (dragging) {
        legL = Math.sin(now * 9) * 16
        legLift = 0
        legRift = 0
      }
      setA('all', 'transform', `translate(0 ${f(bob)}) rotate(${f(lean)} 100 362)`)
      setA('legL', 'transform', `translate(76 284) translate(0 ${f(-legLift)}) rotate(${f(legL)})`)
      setA('legR', 'transform', `translate(124 284) translate(0 ${f(-legRift)}) rotate(${f(-legL)})`)
      const wv = d.wv * Math.sin(now * 11)
      const freeR = clamp(1 - Math.abs(d.aRU + 9) / 35, 0, 1)
      const freeL = clamp(1 - Math.abs(d.aLU - 9) / 35, 0, 1)
      let ruR = d.aRU - swing * 20 * walk * freeR + wv * 6
      let reR = d.aRE + wv * 18
      let ruL = d.aLU - swing * 20 * walk * freeL
      let reL = d.aLE
      if (talking) {
        reR += Math.sin(now * 2.7 + 1) * 6 * freeR
        reL += Math.sin(now * 2.3) * 6 * freeL
      }
      if (dragging) {
        ruR = -125 + Math.sin(now * 13) * 25
        reR = -20
        ruL = 125 - Math.sin(now * 13 + 1) * 25
        reL = 20
      }
      setA('armR', 'transform', `translate(154 222) rotate(${f(ruR)})`)
      setA('foreR', 'transform', `translate(0 40) rotate(${f(reR)})`)
      setA('armL', 'transform', `translate(46 222) rotate(${f(ruL)})`)
      setA('foreL', 'transform', `translate(0 40) rotate(${f(reL)})`)
      setA('chest', 'opacity', f(0.4 + clamp(d.glow, 0, 1) * 0.6))
      const hopK = clamp(-hopY / 34, 0, 1)
      setA('shadow', 'rx', f(46 - hopK * 14 - (dragging ? 12 : 0)))
      setA('shadow', 'opacity', f(0.34 - hopK * 0.14 - (dragging ? 0.12 : 0)))

      let baseR = d.fcR
      let baseL = d.fcL
      let spR = d.spR
      let spL = d.spL
      if (talking && !gk) {
        baseR = clamp(baseR + Math.sin(now * 3.1) * 0.12, 0, 1)
        baseL = clamp(baseL + Math.sin(now * 2.6 + 1) * 0.12, 0, 1)
      }
      if (d.wv > 0.05) spR += Math.sin(now * 11 + 1) * 3 * d.wv
      let tR = arrR || [baseR, baseR, baseR, baseR, baseR]
      let tL = arrL || [baseL, baseL, baseL, baseL, baseL]
      if (dragging) {
        tR = [0, 0, 0, 0, 0]
        tL = [0, 0, 0, 0, 0]
        spR = 20
        spL = 20
      }
      const ff = 1 - Math.exp(-dt * 16)
      for (let k = 0; k < 5; k += 1) {
        st.fing.R[k] += (tR[k] - st.fing.R[k]) * ff
        st.fing.L[k] += (tL[k] - st.fing.L[k]) * ff
      }
      applyHand('R', st.fing.R, spR)
      applyHand('L', st.fing.L, spL)

      const shade = clamp(d.shade, 0, 1)
      setA('shades', 'opacity', f(shade))
      setA('shades', 'transform', `translate(0 ${f(-18 * (1 - shade))})`)

      const tear = clamp(d.tear, 0, 1)
      const tp1 = (now * 0.55) % 1
      const tp2 = (now * 0.55 + 0.5) % 1
      setA('tearL', 'transform', `translate(58 ${f(112 + tp1 * 34)}) scale(${f(0.7 + tp1 * 0.3)})`)
      setA('tearR', 'transform', `translate(142 ${f(112 + tp2 * 34)}) scale(${f(0.7 + tp2 * 0.3)})`)
      setA('tearL', 'opacity', f(tear * Math.min(1, tp1 * 6) * (1 - tp1 * tp1)))
      setA('tearR', 'opacity', f(tear * Math.min(1, tp2 * 6) * (1 - tp2 * tp2)))

      const kp = (now * 0.8) % 1
      setA('kissH', 'transform', `translate(${f(112 + Math.sin(now * 3) * 7 + kp * 18)} ${f(146 - kp * 52)}) scale(${f(0.5 + kp * 0.7)})`)
      setA('kissH', 'opacity', f(clamp(d.kiss, 0, 1) * Math.min(1, kp * 5) * (1 - kp * kp)))

      const zk = (now * 0.5) % 1
      setA('zz', 'opacity', f(clamp(d.zz, 0, 1) * (0.55 + 0.45 * Math.sin(now * 2))))
      setA('zz', 'transform', `translate(${f(zk * 6)} ${f(-zk * 12)})`)
      setA('gem', 'opacity', f(0.5 + glow * 0.5))
      setA('specs', 'opacity', f(1 - shade))
      setA('cape', 'transform', `translate(100 206) skewX(${f(-((st.mv.dx * st.mv.speed) / 125) * 9 + Math.sin(now * 2.2) * 1.6)}) translate(-100 -206)`)
      if (st.sparkOn) {
        const sk = (now - st.spark) / 1.5
        for (let i = 0; i < 6; i += 1) {
          if (sk >= 1) {
            setA(`spk${i}`, 'opacity', '0')
          } else {
            const ang = i * 1.047 + sk * 1.3
            const rad = 30 + sk * 100
            setA(`spk${i}`, 'transform', `translate(${f(100 + Math.cos(ang) * rad)} ${f(170 + Math.sin(ang) * rad * 0.85)}) scale(${f(1.1 - sk * 0.5)}) rotate(${f(sk * 200)})`)
            setA(`spk${i}`, 'opacity', f(1 - sk))
          }
        }
        if (sk >= 1) st.sparkOn = false
      }

      raf = window.requestAnimationFrame(frame)
    }

    raf = window.requestAnimationFrame(frame)
    return () => {
      window.cancelAnimationFrame(raf)
      window.removeEventListener('pointermove', onMove)
      wordSink = null
      commandSink = null
    }
  }, [])

  const poke = () => {
    tapIndex.current = (tapIndex.current + 1) % TAP_ORDER.length
    const name = TAP_ORDER[tapIndex.current]
    const line = TAP_LINES[name]
    const now = performance.now() / 1000
    if (stRef.current) stRef.current.hop = now
    pokeRef.current = { name, until: now + 2.8, talkUntil: now + Math.min(3.2, 0.9 + line.length * 0.07) }
    setLabel(LABELS[name])
    window.clearTimeout(labelTimer.current)
    labelTimer.current = window.setTimeout(() => setLabel(''), 2800)
    if (onSay) onSay(line)
  }

  const onDown = (event) => {
    const st = stRef.current
    if (!st || (event.button && event.button !== 0)) return
    try { event.currentTarget.setPointerCapture(event.pointerId) } catch (err) { /* ignore */ }
    st.drag = { on: true, moved: false, ox: event.clientX - st.pos.x, oy: event.clientY - st.pos.y, sx: event.clientX, sy: event.clientY }
  }

  const onDrag = (event) => {
    const st = stRef.current
    if (!st || !st.drag.on) return
    const g = st.drag
    if (!g.moved && Math.hypot(event.clientX - g.sx, event.clientY - g.sy) > 6) g.moved = true
    if (g.moved) {
      st.pos.x = event.clientX - g.ox
      st.pos.y = event.clientY - g.oy
    }
  }

  const onUp = (event) => {
    const st = stRef.current
    if (!st || !st.drag.on) return
    const moved = st.drag.moved
    st.drag.on = false
    st.drag.moved = false
    try { event.currentTarget.releasePointerCapture(event.pointerId) } catch (err) { /* ignore */ }
    if (moved) {
      st.mv.tgt = null
      st.mv.wait = 1.6
      st.hop = performance.now() / 1000
    } else {
      poke()
    }
  }

  const onCancel = () => {
    const st = stRef.current
    if (!st) return
    st.drag.on = false
    st.drag.moved = false
  }

  const onKey = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      poke()
    }
  }

  const hint = label || (speaking ? 'Talking' : listening ? 'Listening' : thinking ? 'Thinking' : studying ? 'Studying online' : `Lv ${level} · Tap me`)

  return (
    <div
      ref={rootRef}
      className="benRobot"
      role="button"
      tabIndex={0}
      onPointerDown={onDown}
      onPointerMove={onDrag}
      onPointerUp={onUp}
      onPointerCancel={onCancel}
      onKeyDown={onKey}
      aria-label="Ben the robot. Tap to change his expression, drag to move him"
    >
      <svg viewBox="0 0 200 372" role="img" aria-hidden="true" style={{ filter: `drop-shadow(0 10px 18px ${A.shadow})` }}>
        <defs>
          <radialGradient id="benrFace" cx="38%" cy="28%" r="85%">
            <stop offset="0" stopColor="#ffffff" />
            <stop offset="0.55" stopColor="#e8edf3" />
            <stop offset="1" stopColor="#a9b3c2" />
          </radialGradient>
          <radialGradient id="benrIris" cx="50%" cy="45%" r="60%">
            <stop offset="0" stopColor={A.light} />
            <stop offset="0.45" stopColor={A.iris} />
            <stop offset="1" stopColor={A.dark} />
          </radialGradient>
          <linearGradient id="benrSclera" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#d9e1ea" />
            <stop offset="0.4" stopColor="#ffffff" />
            <stop offset="1" stopColor="#e1e8ef" />
          </linearGradient>
          <radialGradient id="benrSocket" cx="50%" cy="50%" r="50%">
            <stop offset="0.55" stopColor="#5b6b85" stopOpacity="0.28" />
            <stop offset="1" stopColor="#5b6b85" stopOpacity="0" />
          </radialGradient>
          <linearGradient id="benrLip" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#e58c96" />
            <stop offset="1" stopColor="#b25566" />
          </linearGradient>
          <linearGradient id="benrSuit" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor={A.suitA} />
            <stop offset="1" stopColor={A.suitB} />
          </linearGradient>
          <radialGradient id="benrShadow" cx="50%" cy="50%" r="50%">
            <stop offset="0" stopColor="#000" stopOpacity="0.9" />
            <stop offset="1" stopColor="#000" stopOpacity="0" />
          </radialGradient>
          <linearGradient id="benrShade" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#3a4b6b" />
            <stop offset="0.5" stopColor="#141a26" />
            <stop offset="1" stopColor="#05070b" />
          </linearGradient>
          <linearGradient id="benrShoe" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#ffffff" />
            <stop offset="1" stopColor="#c6d0dc" />
          </linearGradient>
          <linearGradient id="benrNeck" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#7c8797" />
            <stop offset="1" stopColor="#363e4b" />
          </linearGradient>
          <clipPath id="benrEyeClip">
            <ellipse cx="0" cy="0" rx="17" ry="13" />
          </clipPath>
          <clipPath id="benrMouthClip">
            <path ref={reg('mclip')} d="M0 0" />
          </clipPath>
        </defs>

        <ellipse ref={reg('shadow')} cx="100" cy="364" rx="46" ry="6" fill="url(#benrShadow)" opacity="0.34" />

        <g ref={reg('all')}>
          {has('cape') ? (
            <g ref={reg('cape')}>
              <path d="M52 206 Q18 292 32 352 Q100 334 168 352 Q182 292 148 206Z" fill={A.alt} stroke="rgba(0,0,0,0.3)" strokeWidth="1.5" />
              <path d="M60 214 Q30 292 42 344 Q100 330 158 344 Q170 292 140 214Z" fill={A.altDark} opacity="0.5" />
            </g>
          ) : null}
          <g ref={reg('legL')}>
            <rect x="-10" y="-4" width="20" height="62" rx="10" fill="url(#benrSuit)" />
            <circle cx="0" cy="30" r="8.5" fill="#98a2b2" />
            <path d="M-17 62 Q-19 76 -8 76 L14 76 Q22 76 20 66 Q16 56 8 56 L-8 56 Q-15 56 -17 62Z" fill="url(#benrShoe)" stroke="rgba(60,72,92,0.5)" strokeWidth="1.3" />
            <path d="M-17 72 H20" stroke={A.main} strokeWidth="2.4" strokeLinecap="round" opacity="0.8" />
          </g>
          <g ref={reg('legR')}>
            <rect x="-10" y="-4" width="20" height="62" rx="10" fill="url(#benrSuit)" />
            <circle cx="0" cy="30" r="8.5" fill="#98a2b2" />
            <path d="M-20 66 Q-22 76 -14 76 L8 76 Q19 76 17 62 Q15 56 8 56 L-8 56 Q-16 56 -20 66Z" fill="url(#benrShoe)" stroke="rgba(60,72,92,0.5)" strokeWidth="1.3" />
            <path d="M-20 72 H17" stroke={A.main} strokeWidth="2.4" strokeLinecap="round" opacity="0.8" />
          </g>

          <path d="M50 214 Q50 202 68 202 L132 202 Q150 202 150 214 L147 286 Q100 298 53 286Z" fill="url(#benrSuit)" stroke="rgba(20,26,36,0.6)" strokeWidth="1.5" />
          <path d="M60 210 Q100 220 140 210" fill="none" stroke="rgba(255,255,255,0.14)" strokeWidth="2" />
          <rect x="56" y="268" width="88" height="9" rx="4" fill="#1c222d" />
          <rect x="93" y="266" width="14" height="13" rx="3" fill="#98a2b2" />
          <rect x="72" y="226" width="56" height="34" rx="10" fill="rgba(15,20,30,0.45)" stroke="rgba(255,255,255,0.12)" />
          <circle ref={reg('chest')} cx="100" cy="243" r="9" fill={A.main} opacity="0.5" />
          <circle cx="100" cy="243" r="4.5" fill={A.light} opacity="0.9" />
          <circle cx="100" cy="243" r="13" fill="none" stroke={A.main} strokeWidth="1" opacity="0.4" />
          <path d="M60 215 Q100 232 140 215" fill="none" stroke={A.main} strokeWidth="2.4" strokeLinecap="round" opacity="0.75" />
          <ellipse cx="72" cy="220" rx="16" ry="5" fill="#ffffff" opacity="0.13" transform="rotate(-12 72 220)" />
          <path d="M50 214 Q50 202 68 202 L132 202 Q150 202 150 214" fill="none" stroke="rgba(120,210,255,0.35)" strokeWidth="1.4" />
          <path d="M64 252 H78 M64 258 H74 M122 252 H136 M126 258 H136" stroke="rgba(255,255,255,0.2)" strokeWidth="2" strokeLinecap="round" />

          <rect x="80" y="176" width="40" height="36" rx="8" fill="url(#benrNeck)" />
          <path d="M80 190 H120 M80 198 H120" stroke="rgba(255,255,255,0.12)" strokeWidth="2" />
          {has('scarf') ? (
            <g>
              <path d="M62 198 Q100 218 138 198 L141 216 Q100 236 59 216Z" fill={A.alt} stroke="rgba(0,0,0,0.28)" strokeWidth="1" />
              <path d="M116 220 L136 258 L118 262 L106 228Z" fill={A.alt} stroke="rgba(0,0,0,0.28)" strokeWidth="1" />
              <path d="M74 207 Q100 221 126 207 M121 236 L128 250" fill="none" stroke="rgba(255,255,255,0.32)" strokeWidth="2" strokeDasharray="3 4" strokeLinecap="round" />
            </g>
          ) : null}
          {has('bow') ? (
            <g>
              <path d="M100 216 L76 203 L76 229Z" fill={A.alt} stroke="rgba(0,0,0,0.28)" strokeWidth="1" strokeLinejoin="round" />
              <path d="M100 216 L124 203 L124 229Z" fill={A.alt} stroke="rgba(0,0,0,0.28)" strokeWidth="1" strokeLinejoin="round" />
              <rect x="93" y="208" width="14" height="16" rx="5" fill={A.altDark} stroke="rgba(0,0,0,0.28)" strokeWidth="1" />
            </g>
          ) : null}

        <g ref={reg('head')}>
          {has('headphones') ? <path d="M14 106 C6 -24 194 -24 186 106" fill="none" stroke="#262c37" strokeWidth="8" strokeLinecap="round" /> : null}
          <line x1="100" y1="27" x2="100" y2="13" stroke="#8f98a8" strokeWidth="4" strokeLinecap="round" />
          <circle ref={reg('halo')} cx="100" cy="9" r="11" fill={A.main} opacity="0.2" />
          <circle ref={reg('bulb')} cx="100" cy="9" r="5.5" fill={A.main} />

          <rect x="10" y="84" width="16" height="50" rx="8" fill="#98a2b2" />
          <rect x="174" y="84" width="16" height="50" rx="8" fill="#98a2b2" />
          <rect ref={reg('earL')} x="14" y="91" width="8" height="36" rx="4" fill="none" stroke={A.main} strokeWidth="2.6" />
          <rect ref={reg('earR')} x="178" y="91" width="8" height="36" rx="4" fill="none" stroke={A.main} strokeWidth="2.6" />
          {has('headphones') ? (
            <g>
              <rect x="2" y="80" width="26" height="54" rx="12" fill="#262c37" stroke={A.main} strokeWidth="2.6" />
              <rect x="172" y="80" width="26" height="54" rx="12" fill="#262c37" stroke={A.main} strokeWidth="2.6" />
              <rect x="7" y="88" width="6" height="38" rx="3" fill="#ffffff" opacity="0.14" />
              <rect x="187" y="88" width="6" height="38" rx="3" fill="#ffffff" opacity="0.14" />
            </g>
          ) : null}

          <path d="M100 26 C150 26 178 58 178 108 C178 150 160 190 100 192 C40 190 22 150 22 108 C22 58 50 26 100 26Z" fill="url(#benrFace)" stroke="rgba(60,72,92,0.35)" strokeWidth="1.5" />
          <path d="M30 130 C34 170 60 190 100 192 C140 190 166 170 170 130 C160 168 132 184 100 184 C68 184 40 168 30 130Z" fill="rgba(90,105,130,0.16)" />
          <ellipse cx="78" cy="48" rx="32" ry="11" fill="#ffffff" opacity="0.55" transform="rotate(-14 78 48)" />
          <path d="M100 37 L107 45 L100 53 L93 45Z" fill={A.main} stroke={A.dark} strokeWidth="1" strokeLinejoin="round" ref={reg('gem')} />
          <path d="M100 39.5 L104 44 L100 46 L96 44Z" fill="#ffffff" opacity="0.6" />
          <path d="M40 74 Q46 58 62 48 M160 74 Q154 58 138 48" fill="none" stroke="rgba(255,255,255,0.7)" strokeWidth="2" strokeLinecap="round" />

          {has('beanie') ? (
            <g>
              <path d="M30 60 C24 -6 176 -6 170 60Z" fill={A.alt} stroke="rgba(0,0,0,0.25)" strokeWidth="1.2" />
              <path d="M30 54 Q100 34 170 54 L168 67 Q100 48 32 67Z" fill={A.altDark} stroke="rgba(0,0,0,0.25)" strokeWidth="1" />
              <path d="M52 38 Q100 20 148 38" fill="none" stroke="#ffffff" strokeOpacity="0.3" strokeWidth="3" strokeLinecap="round" />
              <circle cx="100" cy="12" r="9" fill="#ffffff" stroke="rgba(0,0,0,0.2)" />
            </g>
          ) : null}
          {has('flower') ? (
            <g transform="translate(160 52) rotate(12)">
              {[0, 72, 144, 216, 288].map((deg) => (
                <ellipse key={deg} cx="0" cy="-9" rx="5.5" ry="8" fill="#ff8fb8" stroke="rgba(150,40,80,0.4)" strokeWidth="0.8" transform={`rotate(${deg})`} />
              ))}
              <circle cx="0" cy="0" r="5" fill="#ffd84d" stroke="rgba(160,110,0,0.5)" strokeWidth="0.8" />
            </g>
          ) : null}
          <ellipse ref={reg('blushL')} cx="53" cy="128" rx="15" ry="9" fill="#ff8fa3" opacity="0.12" />
          <ellipse ref={reg('blushR')} cx="147" cy="128" rx="15" ry="9" fill="#ff8fa3" opacity="0.12" />

          <path d="M100 106 C98 118 95 124 91 129 C96 134 104 134 109 129 C105 124 102 118 100 106Z" fill="rgba(255,255,255,0.25)" stroke="rgba(100,112,135,0.4)" strokeWidth="1.2" />
          <ellipse cx="95" cy="130.5" rx="1.7" ry="1" fill="rgba(80,92,115,0.5)" />
          <ellipse cx="105" cy="130.5" rx="1.7" ry="1" fill="rgba(80,92,115,0.5)" />

          {[['L', 72], ['R', 128]].map(([side]) => (
            <g key={side} ref={reg(`eye${side}`)}>
              <ellipse cx="0" cy="0" rx="24" ry="19" fill="url(#benrSocket)" />
              <g clipPath="url(#benrEyeClip)">
                <ellipse cx="0" cy="0" rx="17" ry="13" fill="url(#benrSclera)" />
                <g ref={reg(`look${side}`)}>
                  <g ref={reg(`irisG${side}`)}>
                    <circle ref={reg(`irisC${side}`)} cx="0" cy="0" r="9.2" fill="url(#benrIris)" />
                    <circle cx="0" cy="0" r="9.2" fill="none" stroke={A.deep} strokeOpacity="0.6" strokeWidth="1" />
                    <circle cx="0" cy="0" r="6.6" fill="none" stroke="#ffffff" strokeOpacity="0.32" strokeWidth="1.2" strokeDasharray="1 2.2" />
                    <circle ref={reg(`pupilC${side}`)} cx="0" cy="0" r="4.3" fill="#03121b" />
                    <circle cx="3" cy="-3.2" r="2.4" fill="#ffffff" opacity="0.95" />
                    <circle cx="-3.4" cy="2.6" r="1.2" fill="#ffffff" opacity="0.6" />
                  </g>
                  <path ref={reg(`heart${side}`)} d={HEART_D} fill="#ff4d7a" opacity="0" />
                  <g ref={reg(`star${side}`)} opacity="0">
                    <polygon points={starPoints} transform="scale(1.15)" fill="#ffd84d" stroke="#f0a020" strokeWidth="1" strokeLinejoin="round" />
                    <circle cx="-2.5" cy="-3" r="1.6" fill="#ffffff" opacity="0.9" />
                  </g>
                </g>
                <ellipse cx="0" cy="-11" rx="17" ry="6" fill="rgba(0,0,0,0.14)" />
                <path ref={reg(`lower${side}`)} d="M-25 34 L25 34 L25 15 Q0 9 -25 15Z" fill="#e9eef4" />
                <path ref={reg(`upper${side}`)} d="M-25 -34 L25 -34 L25 -14 Q0 -8 -25 -14Z" fill="#e4e9f0" />
                <path ref={reg(`line${side}`)} d="M-25 -14 Q0 -8 25 -14" fill="none" stroke="#3c4657" strokeWidth="2" strokeLinecap="round" />
              </g>
              <ellipse cx="0" cy="0" rx="17" ry="13" fill="none" stroke="rgba(55,66,84,0.5)" strokeWidth="1.3" />
              <path
                d={side === 'L' ? 'M-16 -6 L-23 -10 M-14 -9 L-19 -15 M-10 -11 L-13 -17' : 'M16 -6 L23 -10 M14 -9 L19 -15 M10 -11 L13 -17'}
                fill="none"
                stroke="#3c4657"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </g>
          ))}

          <path ref={reg('browL')} d="M-15 1 Q0 -3.5 15 1" fill="none" stroke="#4c5666" strokeWidth="4.6" strokeLinecap="round" />
          <path ref={reg('browR')} d="M-15 1 Q0 -3.5 15 1" fill="none" stroke="#4c5666" strokeWidth="4.6" strokeLinecap="round" />

          {has('specs') ? (
            <g ref={reg('specs')}>
              <circle cx="72" cy="96" r="25" fill="rgba(190,225,255,0.09)" stroke="#39414f" strokeWidth="3.2" />
              <circle cx="128" cy="96" r="25" fill="rgba(190,225,255,0.09)" stroke="#39414f" strokeWidth="3.2" />
              <path d="M97 94 Q100 89 103 94 M47 93 L27 88 M153 93 L173 88" fill="none" stroke="#39414f" strokeWidth="3" strokeLinecap="round" />
              <path d="M56 84 Q62 78 71 77 M112 84 Q118 78 127 77" fill="none" stroke="#ffffff" strokeOpacity="0.55" strokeWidth="2" strokeLinecap="round" />
            </g>
          ) : null}
          <g ref={reg('shades')} opacity="0">
            <path d="M22 88 L47 90 M178 88 L153 90" stroke="#0d1017" strokeWidth="4" strokeLinecap="round" />
            <path d="M96 92 Q100 86 104 92" fill="none" stroke="#0d1017" strokeWidth="4.5" strokeLinecap="round" />
            <rect x="46" y="79" width="52" height="34" rx="13" fill="url(#benrShade)" stroke="#0d1017" strokeWidth="2.5" />
            <rect x="102" y="79" width="52" height="34" rx="13" fill="url(#benrShade)" stroke="#0d1017" strokeWidth="2.5" />
            <path d="M54 86 L68 86 L58 108 L52 108Z" fill="#ffffff" opacity="0.2" />
            <path d="M110 86 L124 86 L114 108 L108 108Z" fill="#ffffff" opacity="0.2" />
          </g>
          <path ref={reg('dimL')} d="M0 0" fill="none" stroke="rgba(80,90,110,0.5)" strokeWidth="1.4" strokeLinecap="round" opacity="0" />
          <path ref={reg('dimR')} d="M0 0" fill="none" stroke="rgba(80,90,110,0.5)" strokeWidth="1.4" strokeLinecap="round" opacity="0" />
          <path ref={reg('lips')} d="M0 0" fill="url(#benrLip)" stroke="rgba(110,40,55,0.45)" strokeWidth="0.8" strokeLinejoin="round" />
          <path ref={reg('mopen')} d="M0 0" fill="#2a0f16" opacity="0" />
          <g clipPath="url(#benrMouthClip)">
            <rect ref={reg('teeth')} x="80" y="147" width="40" height="4" rx="1.5" fill="#f7f9fb" />
            <ellipse ref={reg('tongue')} cx="100" cy="160" rx="10" ry="5.5" fill="#d9626f" opacity="0" />
          </g>
          <path ref={reg('mline')} d="M0 0" fill="none" stroke="#7a3340" strokeWidth="1.3" strokeLinecap="round" />
          <ellipse ref={reg('gloss')} cx="100" cy="156" rx="7" ry="1.4" fill="#ffffff" opacity="0.35" />
          <g ref={reg('tongueOut')} opacity="0">
            <path d="M-9 0 Q-10 18 0 18 Q10 18 9 0Z" fill="#e2687a" stroke="rgba(110,40,55,0.55)" strokeWidth="0.9" />
            <path d="M0 3 V12" stroke="rgba(110,40,55,0.45)" strokeWidth="1.1" strokeLinecap="round" />
          </g>
          <path ref={reg('tearL')} d="M0 -8 C-5.5 0 -5.5 7 0 7 C5.5 7 5.5 0 0 -8Z" fill="#8fe2ff" stroke="#3aa7d6" strokeWidth="0.9" opacity="0" />
          <path ref={reg('tearR')} d="M0 -8 C-5.5 0 -5.5 7 0 7 C5.5 7 5.5 0 0 -8Z" fill="#8fe2ff" stroke="#3aa7d6" strokeWidth="0.9" opacity="0" />
          <path ref={reg('kissH')} d={HEART_D} fill="#ff4d7a" opacity="0" />
          <g ref={reg('zz')} opacity="0" fill={A.main} fontFamily="system-ui, sans-serif" fontWeight="800" fontStyle="italic">
            <text x="146" y="52" fontSize="14">z</text>
            <text x="160" y="34" fontSize="19">z</text>
            <text x="176" y="12" fontSize="25">Z</text>
          </g>
        </g>

          {['L', 'R'].map((side) => (
            <g key={side} ref={reg(`arm${side}`)}>
              <rect x="-7" y="-4" width="14" height="46" rx="7" fill="url(#benrSuit)" stroke="rgba(20,26,36,0.5)" strokeWidth="1" />
              <rect x="-3.5" y="4" width="3" height="30" rx="1.5" fill="#ffffff" opacity="0.13" />
              <circle cx="0" cy="0" r="10" fill="#98a2b2" />
              <circle cx="-3" cy="-3" r="3.4" fill="#ffffff" opacity="0.35" />
              <g ref={reg(`fore${side}`)}>
                <circle cx="0" cy="0" r="7.5" fill="#98a2b2" />
                <rect x="-6" y="-2" width="12" height="38" rx="6" fill="url(#benrSuit)" stroke="rgba(20,26,36,0.5)" strokeWidth="1" />
                <rect x="-3" y="4" width="2.6" height="26" rx="1.3" fill="#ffffff" opacity="0.13" />
                <rect x="-7.5" y="31" width="15" height="6" rx="3" fill={A.main} opacity="0.75" />
                <g transform={`translate(0 35) scale(${side === 'L' ? '-1.75 1.75' : '1.75 1.75'})`}>
                  {FINGERS.map((fg, i) => (
                    <g key={i} ref={reg(`fg${side}${i}`)} transform={`translate(${fg.x} 8)`}>
                      <rect ref={reg(`fa${side}${i}`)} x="-2.3" y="0" width="4.6" height={fg.l1} rx="2.3" fill="#f2f5f9" stroke="rgba(60,72,92,0.5)" strokeWidth="0.8" />
                      <rect ref={reg(`fb${side}${i}`)} x="-2" y={fg.l1 - 1} width="4" height={fg.l2 + 1} rx="2" fill="#e9eef4" stroke="rgba(60,72,92,0.5)" strokeWidth="0.8" />
                    </g>
                  ))}
                  <g ref={reg(`tm${side}`)} transform="translate(-8 4)">
                    <rect ref={reg(`ta${side}`)} x="-2.6" y="0" width="5.2" height="6.5" rx="2.6" fill="#f2f5f9" stroke="rgba(60,72,92,0.5)" strokeWidth="0.8" />
                    <rect ref={reg(`tb${side}`)} x="-2.2" y="5.5" width="4.4" height="6.5" rx="2.2" fill="#e9eef4" stroke="rgba(60,72,92,0.5)" strokeWidth="0.8" />
                  </g>
                  <ellipse cx="0" cy="3" rx="9.5" ry="8.5" fill="url(#benrFace)" stroke="rgba(60,72,92,0.55)" strokeWidth="1" />
                  <path d="M-5 8 Q0 11 5 8" fill="none" stroke="rgba(60,72,92,0.25)" strokeWidth="1" strokeLinecap="round" />
                  <circle cx="0" cy="2" r="2.4" fill={A.main} opacity="0.6" />
                </g>
              </g>
            </g>
          ))}
        </g>
        {[0, 1, 2, 3, 4, 5].map((i) => (
          <path key={i} ref={reg(`spk${i}`)} d="M0 -8 L2.2 -2.2 L8 0 L2.2 2.2 L0 8 L-2.2 2.2 L-8 0 L-2.2 -2.2Z" fill={i % 2 ? A.alt : A.main} opacity="0" />
        ))}
      </svg>
      <span className="benRobotHint">{hint}</span>
    </div>
  )
}

export default BenRobot
